<div class=" h-500 bg-gray-50 flex items-center justify-center p-4">
    <div class="w-full max-w-md bg-white rounded-lg shadow-sm p-6">
        <!-- Header Section -->
        <div class="text-center mb-8">
            <h1 class="text-3xl font-bold text-gray-900 mb-2">Track Order</h1>
            <p class="text-gray-600 text-base">Locate the progress of your order</p>
        </div>

        <!-- Input Section -->
        <div class="space-y-4">
            <div class="relative">
                <input type="text" [(ngModel)]="awbnumber" placeholder="Enter your tracking number"
                    class="w-full p-4 border border-gray-300 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200" />
            </div>

            <button
                class="w-full bg-gray-700 hover:bg-gray-800 text-white font-medium py-4 px-6 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                (click)="trackOrder()">
                Track
            </button>
        </div>

        <!-- Info Note -->
        <div class="mt-6 p-4 bg-gray-50 rounded-lg">
            <p class="text-sm text-gray-600 leading-relaxed">
                <span class="font-semibold">NOTE:</span> Tracking number is a AWB number that can be found on invoice or
                in order details
            </p>
        </div>

        <!-- Loading State (Optional) -->
        <div *ngIf="isLoading" class="mt-6 flex justify-center">
            <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-700"></div>
        </div>

        <!-- Results Section (Optional) -->
        <div *ngIf="trackingResults" class="mt-6 p-4 bg-blue-50 rounded-lg">
            <h3 class="font-semibold text-gray-900 mb-2">Tracking Results</h3>
            <p class="text-sm text-gray-600">{{ trackingResults?.ShipmentData?.Error ||
                trackingResults?.ShipmentData?.status }}</p>
        </div>
    </div>
</div>